<template>
    <div class="animated fadeIn"> 
      <b-row>
        <b-col sm="12">
          <b-card>
            <div slot="header">
              <strong>Bulk RTD</strong>           
            </div>
            <div class="box" id="addform">
              <form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
                <b-row>
                  <b-col md="4">
                    <b-form-group label="Shipping Id"  :label-cols="4" >
                    <vue-tags-input
                    v-model="shippingid" 
                    :tags="tags"
                    @tags-changed="newTags => tags = newTags  "
                      :avoidAddingDuplicates="avoidAddingDuplicates"
                    :placeholder="placeholder"
                      ref="taginput"
                    v-bind:separators="[',', ';']"
                      />
                      <span class="badge badge-success1">&nbsp;</span>&nbsp;
                      <label :label-cols="4" >Unique Shipping Id</label><br>
                      <span class="badge badge-success2">&nbsp;</span>&nbsp;&nbsp;<label :label-cols="4" >Repeat/Duplicate Shipping Id </label>
                        <span v-show="errors.has('form-1.shipmentid')" class="help text-danger">{{ errors.first('form-1.shipmentid') }}</span>
                    </b-form-group> 
                  </b-col>
                    
                  <b-col md="4">
                    <b-button  :disabled="tags.length == 0" class="mr-4" type="submit" size="md" variant="primary">Mark RTD</b-button>
                    <b-button :disabled="tags.length == 0" @click="clear" size="md" variant="danger">Clear</b-button>
                  </b-col>
                </b-row>            
              </form>
            </div>
            <div slot="footer" v-if="this.invalidshipppingid"  >
              <b-row>
                <b-col md="12">
                  <span>
                    <h6>Invalid Shipmemnts : <strong> {{invalidshipppingid}}</strong></h6> 
                  </span>
                </b-col> 
              </b-row>
            </div>
            
            <b-modal v-if="this.tags.length > 0" title="Confirmation Box" v-model="toggleInfo" size="sm" @ok="toggleInfoModal = false">
              <template slot="modal-header" slot-scope="{ close }">
              <h5>Bulk RTD</h5>
              </template>
              <template slot="default" slot-scope="{ hide }">
                <form v-on:submit.prevent="toggleInfoModal(value)">
                  <div class="modal-background"></div>
                  <div class="modal-card">
                    <section class="modal-card-body">                          
                      <span> Are you sure to bulk RTD ?</span>
                    </section>
                    <footer slot="modal-footer">
                      <b-button variant="primary" size="sm" type="submit">Ok</b-button>
                    </footer>
                  </div>
                </form>
              </template>
              <footer slot="modal-footer" slot-scope="{ cancel }">
                <b-button size="sm" variant="danger" @click="closemodal">
                  Cancel
                </b-button>
              </footer>
            </b-modal>
          </b-card>  
        </b-col>   
      </b-row>
    </div>
  </template>
  
  <script>
  import CONSTANTS from '@/utils/constants'
  import Utils from '@/utils'
  import VueTagsInput from '@johmun/vue-tags-input';
  export default {
    components: {
      VueTagsInput,
    },
    data: function() {
      return {
        name: 'bulkrtd',
        data: [],
        toggleInfo: false,
        avoidAddingDuplicates:false,
        placeholder:"Add shippingid",
        selected:'',
        shippingid: '',
        invalidshipppingid:'',
        tags: [],
        disabled: '',
        selectedusertype:0,
        value:'',
        }
    },
    created: function() {

    },

    methods: {
      validateForm(scope) {
        this.$validator.validateAll(scope).then((result) => {
          if (result) {
            this.toggleInfo = !this.toggleInfo
          }
        })
      },
      
      toggleInfoModal: function () {
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        console.log("pppppppp",userInfo)

         var shipmentid=[];
         for(var i = 0; i < this.tags.length; i++) {
            shipmentid.push(this.tags[i].text);  
         }
        const shipmentobj={
          shippingid:shipmentid,
          lastmodifiedby: `${userInfo.userfirstname}` + " " + `${userInfo.userlastname}`,
          hub_id:`${userInfo.pickuplocationmasterid}`,
        }
        console.log("ooo",shipmentobj)
        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/bulkRTD`, shipmentobj)
          .then((result) => {
              console.log("result",result);
            if (result.body.returnmsg.toLowerCase() === 'successful') {
              this.invalidshipppingid=result.body.invalid_shipment;
              if (result.body.returnvalue >0 ) {
                 Utils.notify('Shipment Bulk RTD successfully'), 
  
                 this.customer = {}
                 this.tags=[];
                
    
               this.errors.clear('form-1')
              }else{
               
              // Utils.notify('invalid shipment id', 'error')
               this.$fire({
                    text: result.body.returnvalue,
                    type: "error",
                    timer: 30000
                  });
  
              }
            } else {
              this.$fire({
                    text: result.body.returnvalue,
                    type: "error",
                    timer: 30000
                  });
              this.invalidshipppingid=result.body.invalid_shipment;
              this.tags=[];
  
            }
          })
          .catch((ex) => {
            console.log('error-----', ex)
          })
        this.toggleInfo = !this.toggleInfo
      },
      closemodal: function () {
        // console.log('closemodal')
        this.toggleInfo = !this.toggleInfo
      },
      clear: function () {
        this.tags=[];
        this.invalidshipppingid="";
        this.errors.clear('form-1')
      },
       GetSortOrder : function(prop) {
          return function(a, b) {
              if (a[prop] > b[prop]) {
                  return 1;
              } else if (a[prop] < b[prop]) {
                  return -1;
              }
              return 0;
          }
  
      },
    },
    filters: {
      capitalize: function(value) {
        if (!value) return ''
        value = value.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
      }
    }
  };
  </script>
  <style >
    .badge-success1
    {
    background-color: #5C6BC0;
      color: #fff;
    }
  .badge-success2
    {
    background-color:  #e54d42;
      color: #fff;
    }
  
  
  </style>
  
  